import FormattedMessage from 'I18n/components/FormattedMessage';
import { HideIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RestrictedAssetContainer = styled.div.withConfig({
  displayName: "ConditionRestrictedAsset__RestrictedAssetContainer",
  componentId: "sc-6avxtb-0"
})(({
  theme
}) => ({
  display: 'inline-block',
  cursor: 'not-allowed',
  color: theme.color['text-primary-disabled']
}));
const ConditionRestrictedAsset = ({
  filterDisplayElement = 'label',
  filterFamily,
  isViewer,
  use = 'labeled'
}) => {
  const {
    getAssetTypeLabelToken
  } = useTranslationHelpers(filterFamily);
  const assetTypeLabelToken = getAssetTypeLabelToken(filterDisplayElement === 'value');
  const tooltipToken = isViewer ? 'noViewOrEditAccess' : 'noEditAccess';
  const restrictedAssetLabelWithTooltip = /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `newCustomerDataFilters.restrictedAsset.${tooltipToken}`
    }),
    children: /*#__PURE__*/_jsxs(RestrictedAssetContainer, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `newCustomerDataFilters.restrictedAsset.assetLabel.${assetTypeLabelToken}`
      }), "\xA0", /*#__PURE__*/_jsx(HideIcon, {
        color: "icon-core-subtle"
      })]
    })
  });
  if (use === 'labeled') {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `newCustomerDataFilters.restrictedAsset.${assetTypeLabelToken}`,
      options: {
        assetLabel: restrictedAssetLabelWithTooltip
      }
    });
  }
  return restrictedAssetLabelWithTooltip;
};
export default ConditionRestrictedAsset;